require('./dropdownList.tpl.html');
require('./dropdownListController');

const DropdownListComponent = {
    templateUrl: '/ui/dropdown/common/list/dropdownList.tpl.html',
    controller: 'umDropdownListController',
    transclude: true,
    bindings: {
        optionList: '<',
        selectedValue: '<',
        searchTerm: '<',
        onSelect: '&'
    }
};

angular.module('umCore')
    .component('umDropdownList', DropdownListComponent);
